// Operations panel (#13): the farmer's own aircraft and the work order, at the
// top of the side bay. Rows update in place (syncList) so clicks never land
// on a row that was just rebuilt.

import { FIELDS, SPRAY_WIND_MIN, SPRAY_WIND_MAX } from '../config/constants.js';
import { $, setText, setClass, syncList } from './dom.js';
import { energyText } from '../core/energy.js';

const AIRCRAFT_STATUS = {
  parked: 'Parked', outbound: 'Outbound', working: 'Working', sprayHold: 'Spray hold', returning: 'Returning', holding: 'Holding',
  peopleHold: 'Person in field', padHold: 'Pad blocked', recharging: 'Refilling',
};
const FIELD_STATUS = {
  unscouted: 'To scout', scouting: 'Scouting', clear: 'Clear', spraying: 'Spraying', sprayed: 'Sprayed',
};

function aircraftLine(a) {
  const field = a.task ? FIELDS[a.task.fieldIdx].name : null;
  if (a.state === 'parked') return `At ${a.padName}`;
  if (a.state === 'sprayHold') return `${field}: waiting for ${SPRAY_WIND_MIN}–${SPRAY_WIND_MAX} mph`;
  if (a.state === 'returning') return `To ${a.padName}`;
  if (a.state === 'padHold') return `Over ${a.padName}: pad blocked`;
  if (a.state === 'recharging') return `${a.power === 'ev' ? 'Charging' : 'Refueling'} at ${a.padName}`;
  return field ? `${a.task.kind === 'scout' ? 'Scouting' : 'Spraying'} ${field}` : '';
}

export function createOpsPanel(listEl, countEl, { onSelect }) {
  const cache = new Map();

  listEl.addEventListener('click', (e) => {
    const row = e.target.closest('[data-id]');
    if (row && row.dataset.kind === 'aircraft') onSelect(row.dataset.id);
  });

  function create(item) {
    const el = document.createElement('div');
    el.dataset.id = item.id;
    el.dataset.kind = item.kind;
    if (item.kind === 'aircraft') el.tabIndex = 0;
    el.innerHTML = '<span class="o-name"></span><span class="o-line"></span><span class="o-status"></span>';
    return el;
  }

  function update(el, item, selectedId) {
    if (item.kind === 'aircraft') {
      const a = item.a;
      const warn = a.alert ? ' alert' : (a.predict ? ' predict' : '');
      setClass(el, `ops-row aircraft ${a.state}${warn}${a.id === selectedId ? ' selected' : ''}`);
      el.style.setProperty('--type-color', a.color);
      setText($('.o-name', el), a.call);
      // battery or fuel first (#32), then what it's doing
      setText($('.o-line', el), `${energyText(a)} · ${aircraftLine(a)}`);
      el.classList.toggle('low', a.energy < 0.25);
      let status = AIRCRAFT_STATUS[a.state];
      if (a.alert) status = 'Conflict';
      else if (a.predict) status = `Conflict ${Math.ceil(a.predict.in)}s`;
      setText($('.o-status', el), status);
    } else {
      const f = item.f;
      const pct = f.state === 'scouting' ? f.sweep.progress : (f.state === 'spraying' ? f.spray.progress : null);
      setClass(el, `ops-row field ${f.state}`);
      setText($('.o-name', el), f.name);
      setText($('.o-line', el), pct === null ? '' : `${Math.round(pct * 100)}%`);
      setText($('.o-status', el), FIELD_STATUS[f.state]);
    }
  }

  return {
    update(s, selectedId) {
      const ops = s.ops;
      if (!ops) { setText(countEl, '—'); syncList(listEl, cache, [], create, update); return; }
      setText(countEl, `${ops.sprayed}/${ops.fields.length} sprayed`);
      const items = [
        ...ops.aircraft.map((a) => ({ id: a.id, kind: 'aircraft', a })),
        ...ops.fields.map((f) => ({ id: `field-${f.idx}`, kind: 'field', f })),
      ];
      syncList(listEl, cache, items, create, (el, item) => update(el, item, selectedId));
    },
  };
}
